import { Button } from '@/components/ui/Button';
interface GameLobbyProps {
  onStartGame: () => void;
  onHowToPlay: () => void;
}
export function GameLobby({ onStartGame, onHowToPlay }: GameLobbyProps) {
  return (
    <div
      className="h-full w-full flex flex-col items-center justify-center p-6 bg-[#FFF8E7]"
      style={{
        background: 'radial-gradient(circle at 50% 30%, #FFF8E7 0%, #F5E6D3 100%)',
      }}
    >
      <div className="flex flex-col items-center gap-8 w-full max-w-[320px]">
        <div className="flex flex-col items-center gap-2">
          <h1 className="text-4xl font-extrabold text-[#1a1a1a] text-center leading-tight">
            Block Dodge
          </h1>
          <h2 className="text-2xl font-bold text-[#E63946]">Survivor</h2>
        </div>
        <div className="bg-white rounded-3xl shadow-[8px_8px_0_0_#E5DDD0] p-6 w-full">
          <div className="flex flex-col gap-4">
            <Button onClick={onStartGame} variant="primary">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              Start Game
            </Button>
            <Button onClick={onHowToPlay} variant="secondary">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              How to Play
            </Button>
          </div>
        </div>
        <p className="text-sm text-[#6B7280] text-center">
          Dodge the falling blocks!
        </p>
      </div>
    </div>
  );
}